import { navigate } from 'gatsby-link'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import Component from '@cinch/oxd-components/compare-bar/src'
import { closeDrawer, openDrawer, removeVehicle } from '@cinch/oxd-redux/compare/src/actions'
import { getVehicles } from '@cinch/oxd-redux/compare/src/selectors'

export const mapStateToProps = (state: any) => {
  const items = getVehicles(state)

  return {
    items,
    showDrawer: items.length > 0,
    defaultExpanded: state.compare.isDrawerOpen,
  }
}

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  onRemove: (id: number) => dispatch(removeVehicle(id, 'bar')),
  onOpen: () => dispatch(openDrawer()),
  onClose: () => dispatch(closeDrawer()),
  goCompare: (ids: number[]) => navigate(`/compare?vehicleIds=${ids.join(',')}`),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
